import React from 'react';

const backgroundRed = { background: 'red' };

const Row = ({ params, row }) => {
    let td = getValues(params, row);

    return (
        <tr>{td}</tr>
    );
};

function getValues(params, row) {
    return params.map((param, index) => {
        const value = row[index];

        const styles = value < 0 ? backgroundRed : {};

        return(<td style={styles} key={param}>{value}</td>);
    });
}

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderBids/components/Table/components/Row/index.js